import React from "react";
import { useNavigate } from "react-router-dom";
import InputField from "components/fields/InputField";
import { apiLogin, setSessao } from "utils/api";

export default function SignIn() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [senha, setSenha] = React.useState("");
  const [erro, setErro] = React.useState("");
  const [carregando, setCarregando] = React.useState(false);

  async function entrar(e) {
    e.preventDefault();
    setErro("");
    setCarregando(true);
    try {
      const data = await apiLogin(email.trim(), senha);
      if (!data.success) throw new Error(data.error || "Não foi possível entrar.");
      setSessao(data.token, data.admin);
      navigate("/admin/assinantes", { replace: true });
    } catch (err) {
      setErro(err.message);
    } finally {
      setCarregando(false);
    }
  }

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Painel Findule
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Acesso restrito à equipe interna do Findule.
        </p>

        <form onSubmit={entrar}>
          {erro && (
            <div className="mb-4 rounded-xl border border-red-400 bg-red-50 px-3 py-2 text-sm text-red-600 dark:border-red-400 dark:bg-navy-800 dark:text-red-300">
              {erro}
            </div>
          )}

          <InputField
            variant="auth"
            extra="mb-3"
            label="E-mail*"
            placeholder="voce@findule.com.br"
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <InputField
            variant="auth"
            extra="mb-3"
            label="Senha*"
            placeholder="Sua senha"
            id="senha"
            type="password"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            required
          />

          <button
            type="submit"
            disabled={carregando}
            className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:opacity-60 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
          >
            {carregando ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
